import { BugReport as DebugIcon } from '@mui/icons-material';
import { SxProps, Theme, ToggleButton, ToggleButtonProps } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

export type ToggleDebugButtonProps = {
  debug: boolean;
  setDebug: Dispatch<SetStateAction<boolean>>;
  sx?: SxProps<Theme>;
  size?: ToggleButtonProps['size'];
};

export default function ToggleDebugButton({ debug, setDebug, size, sx }: ToggleDebugButtonProps) {
  return (
    <ToggleButton
      sx={{
        zIndex: 9999,
        backgroundColor: 'transparent',
        borderRadius: '100px',
        border: 'none',
        ...sx,
      }}
      size={size ?? 'small'}
      value="check"
      selected={debug}
      onChange={() => {
        setDebug((x) => !x);
      }}
      aria-label="Toggle debug mode"
    >
      <DebugIcon />
    </ToggleButton>
  );
}
